
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"id":"backgroundrect","width":"100%","height":"100%","x":"0","y":"0","fill":"none","stroke":"none"}}),_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M0 0h17.555v17.555H0z","id":"svg_1","fill":"none"}})])]),_c('g',{staticClass:"currentLayer"},[_c('g',{staticClass:"selected",attrs:{"id":"svg_2"}},[_c('g',{attrs:{"id":"svg_3"}},[_c('g',{attrs:{"id":"svg_4","clip-path":"url(#a)"}},[_c('g',{attrs:{"id":"svg_5"}},[_c('path',{attrs:{"d":"M17.556 8.778A8.778 8.778 0 008.778 0 8.778 8.778 0 000 8.778a8.745 8.745 0 002.26 5.88v1.441c0 .8.492 1.457 1.1 1.457h5.83a.843.843 0 00.183-.02 8.778 8.778 0 008.184-8.757","id":"svg_6","fill":"#fff"}})]),_c('g',{attrs:{"id":"svg_7"}},[_c('path',{attrs:{"d":"M3.161 8.921A9.292 9.292 0 019.541.033 8.763 8.763 0 008.778 0 8.774 8.774 0 000 8.778 9.508 9.508 0 002.224 14.7c.005 0 0 .01 0 .01-.31.352-1.924 2.85.021 2.85h2.25c-1.23-.023 1.263-2.108.27-3.495a8.225 8.225 0 01-1.6-5.14","id":"svg_8","fill":"#eff4f9"}})])])])])])])
          )
        }
      }
    